<h1>Reporting</h1>

<div
  style="
    border: 1px solid #dddddd;
    background-color: #fafafa;
    padding: 10px;
    border-radius: 10px 3px 10px 3px;
    font-size: 1.1em;
    margin-bottom: 20px;
  "
>
  Gateway Account Billing
</div>

<div
  style="
    border: 1px solid #dddddd;
    background-color: #fafafa;
    padding: 10px;
    border-radius: 10px 3px 10px 3px;
    font-size: 1.1em;
    margin-bottom: 20px;
  "
>
  Transactions
</div>
